import { render, staticRenderFns } from "./user-info-edit.vue?vue&type=template&id=47c7aec4&"
import script from "./user-info-edit.vue?vue&type=script&lang=js&"
export * from "./user-info-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports